var FilteredShadowMapMethod = (function () {
    function FilteredShadowMapMethod() {
    }
    return FilteredShadowMapMethod;
}());
export { FilteredShadowMapMethod };
